import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TextButton } from "@qgiv/core-donor";
import { Icon } from "@qgiv/core-react";

const ClassificationSummary = ({
    baseUrl,
    classificationLabel = "",
    classificationName = "",
    changeParticipantDetailsLinkLabel = "Change",
    isVisible,
    hasParentRegistration,
    isCms,
}) =>
    isVisible && (
        // eslint-disable-next-line tailwindcss/classnames-order
        <div className="grid grid--no-left-gutter">
            <div className="col col--12 -margin-bottom--30">
                <small>
                    {classificationName ? (
                        <span>{classificationName}</span>
                    ) : (
                        <span className="-color--system-error">
                            <Icon
                                className="-type--regular -margin-right--10 -color--system-error"
                                glyph="exclamation-circle-solid"
                                type="FontAwesome"
                            />
                            {`Please select a ${classificationLabel || "classification"}`}
                        </span>
                    )}

                    <br />
                    {!hasParentRegistration ? (
                        // eslint-disable-next-line react/jsx-no-useless-fragment
                        <>
                            {isCms ? (
                                <TextButton>
                                    <strong>
                                        {changeParticipantDetailsLinkLabel}
                                    </strong>
                                </TextButton>
                            ) : (
                                <Link to={`${baseUrl}/form/classification`}>
                                    <strong>
                                        {changeParticipantDetailsLinkLabel}
                                    </strong>
                                </Link>
                            )}
                        </>
                    ) : null}
                </small>
            </div>
        </div>
    );

ClassificationSummary.propTypes = {
    // Start of navigate url which includes event alias
    baseUrl: PropTypes.string.isRequired,
    classificationLabel: PropTypes.string,
    // Name of the selected classification
    classificationName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    // Customized change label
    changeParticipantDetailsLinkLabel: PropTypes.string,
    // Flag that let's us know this registration started at the Fundraising Center
    hasParentRegistration: PropTypes.bool.isRequired,
    // Flag telling us to display the classification summary
    isVisible: PropTypes.bool.isRequired,
    isCms: PropTypes.bool.isRequired,
};

export default ClassificationSummary;
